import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import ImplementationPackageForm from './ImplementationPackageForm';
import { currencySymbols } from 'internationalization/currencySymbols';
import { parsePriceToStringOnUserLocale } from 'services/utils/parsePriceString';
import { useSettings } from 'services/settings/SettingsContext';
import { useTranslation } from 'react-i18next';

// Rename the name of the function:
const ImplementationPackageList: React.FC = () => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        {
            width: '1fr',
            field: 'name',
            label: 'billing.implementation_package.name_label'
        },
        {
            width: '2fr',
            field: 'price',
            label: 'billing.implementation_package.price_label',
            render: (_, row) => (
                <span>
                    {currencySymbols['eur']} {parsePriceToStringOnUserLocale(row.price, userLocale, false)} {t('billing.implementation_package.one_time_label')}
                </span>
            )
        },
    ];

    return (
        <AbstractList
            query={{
                endpoint: 'get_implementation_package_list',
                defaultParams: { is_active: true },
                object: 'implementation_package'
            }}
            objectName='billing.implementation_package.object_name'
            columns={columns}
            showSearch={false}
            showAddButton={true}
            isPaginated={false}
            isDraggable={true}
            draggingApiUrl='patch_implementation_package_ordering'
            showDeleteOrDeactivate='flag_deactivated'
            formModal={<ImplementationPackageForm />}
            onRowClick='editModal'
        />
    );
};

export default ImplementationPackageList;
